module.exports = __webpack_public_path__ + "img/Scream-Music-Composer1.c67276a3.png";